import PropTypes from 'prop-types';
export const Svg = ({ children, ...props }) => {
  console.warn(
    'react-native-svg components are not fully supported on web platform',
  );
  return null;
};

Svg.propTypes = {
  children: PropTypes.node,
};

export const Circle = () => null;
export const Ellipse = () => null;
export const G = () => null;
export const Text = () => null;
export const TSpan = () => null;
export const TextPath = () => null;
export const Path = () => null;
export const Polygon = () => null;
export const Polyline = () => null;
export const Line = () => null;
export const Rect = () => null;
export const Use = () => null;
export const Image = () => null;
export const Symbol = () => null;
export const Defs = () => null;
export const LinearGradient = () => null;
export const RadialGradient = () => null;
export const Stop = () => null;
export const ClipPath = () => null;
export const Pattern = () => null;
export const Mask = () => null;

export default Svg;
